/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationPreferenceDeliveryScopeType } from './NotificationPreferenceDeliveryScopeType';
import {
    NotificationPreferenceDeliveryScopeTypeFromJSON,
    NotificationPreferenceDeliveryScopeTypeFromJSONTyped,
    NotificationPreferenceDeliveryScopeTypeToJSON,
} from './NotificationPreferenceDeliveryScopeType';

/**
 * 
 * @export
 * @interface PreferenceDeliveryScopeApplyToAllRequest
 */
export interface PreferenceDeliveryScopeApplyToAllRequest {
    /**
     * 
     * @type {string}
     * @memberof PreferenceDeliveryScopeApplyToAllRequest
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof PreferenceDeliveryScopeApplyToAllRequest
     */
    preference_id: string;
    /**
     * 
     * @type {NotificationPreferenceDeliveryScopeType}
     * @memberof PreferenceDeliveryScopeApplyToAllRequest
     */
    delivery_scope: NotificationPreferenceDeliveryScopeType;
}

/**
 * Check if a given object implements the PreferenceDeliveryScopeApplyToAllRequest interface.
 */
export function instanceOfPreferenceDeliveryScopeApplyToAllRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "preference_id" in value;
    isInstance = isInstance && "delivery_scope" in value;

    return isInstance;
}

export function PreferenceDeliveryScopeApplyToAllRequestFromJSON(json: any): PreferenceDeliveryScopeApplyToAllRequest {
    return PreferenceDeliveryScopeApplyToAllRequestFromJSONTyped(json, false);
}

export function PreferenceDeliveryScopeApplyToAllRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreferenceDeliveryScopeApplyToAllRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'preference_id': json['preference_id'],
        'delivery_scope': NotificationPreferenceDeliveryScopeTypeFromJSON(json['delivery_scope']),
    };
}

export function PreferenceDeliveryScopeApplyToAllRequestToJSON(value?: PreferenceDeliveryScopeApplyToAllRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.user_id,
        'preference_id': value.preference_id,
        'delivery_scope': NotificationPreferenceDeliveryScopeTypeToJSON(value.delivery_scope),
    };
}

